const getCount = state => state.count
const getSections = state => state.sections
const getTemplatePlayers = state => state.templatePlayers
const getUserPlayers = state => state.userPlayers
const getCompetition = state => state.competition

const getUserPlayersMiddleStats = state => state.stats

const getTemplateId = state => state.templateId

export default {
  getCount,
  getSections,
  getTemplatePlayers,
  getUserPlayers,
  getUserPlayersMiddleStats,
  getTemplateId,
  getCompetition
}



// WEBPACK FOOTER //
// ./src/store/modules/results/getters.js